import { render, staticRenderFns } from "./CallLogsTable.vue?vue&type=template&id=4a1b5972&scoped=true&"
import script from "./CallLogsTable.vue?vue&type=script&lang=js&"
export * from "./CallLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./CallLogsTable.vue?vue&type=style&index=0&id=4a1b5972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b5972",
  null
  
)

export default component.exports